import { Link } from 'react-router-dom';
import { mockPosts } from '../../api/mockData';

const ArchivePage = () => {
  return (
    <div style={{ maxWidth: 800, margin: '0 auto', padding: '24px' }}>
      <h1 style={{ color: '#121111ff', marginBottom: 24 }}>NBA文章归档</h1>
      <ul style={{ listStyle: 'none', padding: 0 }}>
        {mockPosts.map(post => (
          <li key={post.id} style={{ padding: 8, borderBottom: '1px solid #eee' }}>
            <Link to={`/post/${post.id}`} style={{ color: '#0b0a0aff', textDecoration: 'none' }}>
              {post.title}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ArchivePage;